import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { SessionService } from '@/app/core/services/session';
import { NamedRouter } from '@/app/core/services/named-router';

export const guestGuard: CanMatchFn = () => {
  const namedRouter = inject(NamedRouter);
  const sessionsService = inject(SessionService);

  if (sessionsService.isAuthenticated()) {
    namedRouter.navigateByName('gyms-list');

    return false;
  }

  return true;
};
